import { Link } from 'react-router-dom'
import styled from 'styled-components'

export const Nav = styled.nav`
  display: flex;
`

export const NavIcon = styled(Link)`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 2rem;
  height: 80px;
`

export const Logo = styled.div`
  display: flex;
  width: fit-content;
  height: fit-content;
  padding: 2rem;
`

export const Title = styled.span`
  color: ${(props) => props.theme.color.neutral.gray};
  font-size: ${(props) => props.theme.font.textcaption};
  margin-bottom: 0.5rem;
`

export const Menu = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem;
`

export const SidebarNav = styled.nav`
  background: #f5f5f5;
  border-right: 2px solid #49494930;
  width: fit-content;
  max-width: 15rem;
  height: 100vh;
  top: 0;
  z-index: 10;
  position: relative;
  display: flex;
  /* justify-content: center; */
`

export const SidebarWrap = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  overflow: auto;
  &::-webkit-scrollbar {
    display: none;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }

  > div {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
`

export const UserInfos = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem;

  .logOff {
    display: flex;
    height: 100%;
  }
`

export const SidebarLink = styled(Link)`
  display: flex;
  color: #494949;
  justify-content: space-between;
  align-items: center;
  list-style: none;
  height: 60px;
  text-decoration: none;
  font-size: 18px;

  > div {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  &:hover {
    background: #edf4fc;
    border: 1px solid #067fb7;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    border-bottom: 4px solid #067fb7;
    cursor: pointer;
  }
`

export const SidebarLabel = styled.span`
  margin-left: 16px;

  ul {
    &:hover {
      cursor: pointer;
      text-decoration: underline;
    }
  }

  &:hover {
    cursor: pointer;
  }
`

export const DropdownLink = styled(Link)`
  height: 40px;
  border-left: 4px solid #067fb7;
  padding-left: 1rem;
  margin-left: 1rem;
  display: flex;
  align-items: center;
  text-decoration: none;
  color: ${(props) => props.theme.color.neutral.gray};
  font-size: ${(props) => props.theme.font.textcaption};

  &:hover {
    cursor: pointer;
    background: #edf4fc;
    border: 1px solid #067fb7;
    border-left: 4px solid #067fb7;
  }
`

export const PerfilItem = styled.div`
  display: flex;
  color: #494949;
  align-items: center;
  list-style: none;
  min-height: 3rem;
  text-decoration: none;
  font-size: 18px;
  flex: 1;

  &:hover {
    background: #edf4fc;
    border: 1px solid #067fb7;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    border-bottom: 4px solid #067fb7;
    cursor: pointer;
  }
`

interface PerfilContainerProps {
  isOpen: boolean
}

export const PerfilTab = styled.div<PerfilContainerProps>`
  position: absolute;
  display: ${(props) => (props.isOpen ? 'flex' : 'none')};
  z-index: 3;
  width: fit-content;
  height: 100%;
  background-color: ${(props) => props.theme.color.neutral.background};
  left: 15rem;
  padding: 1rem;
`

export const PerfilContainer = styled.div`
  background-color: ${(props) => props.theme.color.neutral.white};
  border-radius: ${(props) => props.theme.border.radius};
  width: 30rem;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  height: fit-content;
`

export const PerfilHeader = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;

  > span {
    display: flex;
    padding: 0.3125rem;
    align-items: flex-start;
    border-radius: 0.375rem;
    background: ${(props) => props.theme.color.blue.blue50};
    cursor: pointer;
  }
`

export const PerfilBody = styled.form`
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 1rem;
`

export const PerfilUserPhoto = styled.div`
  display: flex;
  /* flex: 1; */
  align-items: center;
  position: relative;

  > div {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    bottom: 0;
    right: 0;
    cursor: pointer;

    > svg {
      background-color: #fff;
      border-radius: 2px;
      border: 3px solid #494949;
    }
  }

  > img {
    background-color: transparent;
    width: 10rem;
    height: 10rem;
    border-radius: 8px;
    border: 3px solid #494949;
  }
`

export const InputFileContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 0 1rem;
`

export const PlaceHolderFile = styled.p`
  width: 100%;
  margin-left: 1rem;
  font-size: ${(props) => props.theme.font.textcaption};
  position: absolute;
  cursor: pointer;
`

export const Overlay = styled.div<PerfilContainerProps>`
  position: fixed;
  display: ${(props) => (props.isOpen ? 'block' : 'none')};
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 2;
  cursor: pointer;
`

export const LogOffButton = styled.button`
  display: flex;
  align-items: center;
  background-color: #49494905;
  color: #fff;
  min-height: 3rem;
  flex: 1;
  width: 100%;
  gap: 1rem;
  border-radius: 11px;
  border: none;
  text-align: right;
  transition: all 0.6s ease;

  &:hover {
    cursor: pointer;
  }

  svg {
    display: flex;
    transition: all 0.6s ease;
  }

  &:hover svg {
    transform: translateX(5px);
  }

  span {
    color: #494949;
    align-items: center;
    list-style: none;
    text-decoration: none;
    font-size: 18px;
  }
`
